import { Button, Card, Form, Spin, message } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import moment from 'moment';
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState
} from 'react';

import { useHistory, useLocation } from 'react-router-dom';
import { Subtitle, Title } from '../../components';
import LogosEmpresaAseguradora from '../../components/LogosEmpresaAseguradora';
import ReconfirmarCIAModal from '../../components/ReconfirmarCIAModal';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import SolicitudRealizada from '../../components/SolicitudRealizada';
import StepperSolicitud from '../../components/StepperSolicitud';
import { ESTADOS, NACIONALIDADES } from '../../constants';
import EmpresaContext from '../../context/empresa-context';
import {
  SolicitudProvider,
  useSolicitudContext
} from '../../context/solicitud-context';
import {
  consultarCliente,
  errorHandler,
  formatCelular,
  parseCelular,
  scrollToRef
} from '../../utils';
import { instanceRef } from '../../utils/axios';
import DescripcionesCartaVerde from './DescripcionesCartaVerde';
import DocumentosCartaVerdeUpload from './DocumentosCartaVerdeUpload';
import PagosCartaVerdeForm from './PagosCartaVerdeForm';
import SolicitudCartaVerdeForm from './SolicitudCartaVerdeForm';

const concatTelefono = (prefijo, sufijo) => {
  if (prefijo.length === 0 && sufijo.length === 0) {
    return null;
  }
  return prefijo.concat(` ${sufijo}`);
};

const PreSolicitudFormFinal = ({ fullPath, ...props }) => {
  const screens = useBreakpoint();
  const myRef = useRef(null);
  const history = useHistory();

  const scrollTop = () => setTimeout(() => scrollToRef(myRef));

  const [formData, setFormData] = useState({
    documentos: {}, // Datos del paso 1
    solicitud: { vehiculo: {}, persona: {}, facturacion: {} }, // Datos del paso 2
    confirmacion: {} // Datos del paso 3
  });
  const [loading, setLoading] = useState(false);
  const [cotizacion, setCotizacion] = useState();

  const [solicitado, setSolicitado] = useState(false);
  const [current, setCurrent] = useState(0);
  // const [principalLoading, setPrincipalLoading] = useState(false);
  const [subpasoDocumentos, setSubpasoDocumentos] = useState(0);
  const [documentosData, setDocumentosData] = useState();
  const [cedulaVerde1, setCedulaVerde1] = useState('');
  const [cedulaVerde2, setCedulaVerde2] = useState('');
  const [cedulaIdentidad1, setCedulaIdentidad1] = useState('');
  const [cedulaIdentidad2, setCedulaIdentidad2] = useState('');
  const [mostrarConfirmarCedula, setMostrarConfirmarCedula] = useState(false);
  const [numeroCedula, setNumeroCedula] = useState();
  const [numeroCedulaModificada, setNumeroCedulaModificada] = useState();
  const [confirmarCedulaLoading, setConfirmarCedulaLoading] = useState(false);
  const [loadingPrincipalImagen, setLoadingPrincipalImagen] = useState(false);

  const [formVehiculo] = Form.useForm();
  const [formAsegurado] = Form.useForm();
  const [formLaborales] = Form.useForm();
  const [formPeriodo] = Form.useForm();
  const [formMetodo] = Form.useForm();
  const [formCedula] = Form.useForm();

  const { empresa } = useContext(EmpresaContext);
  const { solicitarRequest } = useSolicitudContext();
  const [fields, setFields] = useState({
    marca: null,
    modelo: null,
    submodelo: null,
    anio: null,
    monto: 0,
    chassis: null,
    chapa: null,
    color: undefined,
    otroColor: undefined,
    origen: null,
    anioFabricacion: null,
    anioInscripcion: null,
    combustible: null,
    tipoUso: null,
    ocupantes: null,
    id: null,
    nombres: null,
    nombre: null,
    apellido: null,
    prefix: '+595',
    celular: null,
    cedula: null,
    cedulaOrRuc: null,
    correo: null,
    sexo: undefined,
    lugarNacimiento: null,
    fechaNacimiento: null,
    domicilio: null,
    departamento: undefined,
    distrito: undefined,
    nacionalidad: undefined,
    estadoCivil: undefined,
    latitud: null,
    longitud: null,
    personaBCP: null,
    departamentoZonaCirculacion: null,
    distritoZonaCirculacion: null,

    ruc: null,
    profesion: null,
    ingresos: null,
    proveedorEstado: false,
    politicamenteExpuesto: false,
    trabajo: undefined,
    institucion: undefined,
    cargo: null,
    anioIngreso: null,
    empresaEmpleador: null,
    rucEmpleador: null,
    telefonoEmpleador: null,
    celularEmpleador: null,
    direccionEmpleador: null,

    vigencia: null,

    formaPago: null,
    metodoPago: null,
    titularTarjeta: null,
    numeroTarjeta: null,
    vencimientoTarjeta: null,

    numeroCuenta: null,
    tercero: {
      nombres: null,
      cedula: null,
      ruc: null,
      celular: null,
      domicilio: null,
      correo: null,
      telefono: null
    },
    endoso: null
  });

  const steps = [
    {
      title: 'Paso 1',
      description: (
        <span>
          Subí las <strong>Fotos de tus Documentos</strong>
        </span>
      )
    },
    {
      title: 'Paso 2',
      description: (
        <span>
          Cargá <strong>tus Datos</strong>
        </span>
      )
    },
    {
      title: 'Paso 3',
      description: (
        <span>
          ¡Confirmá tu <strong>Solicitud</strong>!
        </span>
      )
    }
  ];

  const validateStep = (step, subpaso) => {
    switch (step) {
      case 0:
        if (current === 0) {
          if (subpaso === 0) {
            if (!documentosData || !documentosData.CVA || !documentosData.CVD) {
              message.warning('Debe cargar su cédula verde (ambos lados)');
              return false;
            }
          }
          if (subpaso === 1) {
            if (!documentosData || !documentosData.CIA || !documentosData.CID) {
              message.warning(
                'Debe cargar la cédula de identidad (ambos lados)'
              );
              return false;
            }
          }
        }

        return true;
      default:
        return true;
    }
  };

  const onAnterior = () => {
    if (current === 0 && subpasoDocumentos === 1) {
      setSubpasoDocumentos(0);
    } else if (current > 0 && numeroCedulaModificada) {
      setNumeroCedulaModificada(null);
      setCurrent(current - 1);
    } else {
      setCurrent(current - 1);
    }
  };

  const onSiguiente = async () => {
    setLoading(true);

    if (current === 0 && subpasoDocumentos === 1) {
      if (!documentosData.CIA?.datosCoincideBCP && !numeroCedulaModificada) {
        setMostrarConfirmarCedula(true);
        return;
      }
    }
    const validoVehiculo = await validate(formVehiculo);
    if (!validoVehiculo) {
      setLoading(false);
      return;
    }

    const validoAsegurado = await validate(formAsegurado);
    if (!validoAsegurado) {
      setLoading(false);
      return;
    }

    if (validoAsegurado) {
      const nombreForm = formAsegurado.getFieldValue('nombre')?.toUpperCase();
      const apellidoForm = formAsegurado
        .getFieldValue('apellido')
        ?.toUpperCase();

      const nombreApellido = `${apellidoForm}, ${nombreForm}`;
      formAsegurado.setFieldValue('nombres', nombreApellido);
      updateData('fields', { nombres: nombreApellido });
    }

    const validoLaborales = await validate(formLaborales);
    if (!validoLaborales) {
      setLoading(false);
      return;
    }

    const validoPeriodo = await validate(formPeriodo);
    if (!validoPeriodo) {
      setLoading(false);
      return;
    }

    const validoMetodo = await validate(formMetodo);
    if (!validoMetodo) {
      setLoading(false);
      return;
    }
    const valido = validateStep(current, subpasoDocumentos);
    if (valido) {
      if (current === 0 && subpasoDocumentos === 0) {
        setSubpasoDocumentos(1);
      } else {
        setCurrent((prev) => prev + 1);
        scrollTop();
      }
    }
    setLoading(false);
  };

  // Validate Form
  const validate = async (formInstance) => {
    try {
      await formInstance.validateFields();
      return true;
    } catch (error) {
      handleValidationError(error, formInstance);
      return false;
    }
  };

  const handleValidationError = (error, formInstance) => {
    if (error && error.errorFields && error.errorFields.length > 0) {
      const firstErrorField = error.errorFields[0].name;
      formInstance.scrollToField(firstErrorField, {
        behavior: 'smooth',
        block: 'center'
      });
    }
  };

  const getCotizacion = useCallback(async () => {
    const { token } = props.match.params;

    try {
      setLoading(true);
      const url = `cotizacion/cv-token?token=${token}&solicitar=true&estado=ENVIADO`;
      const response = await instanceRef.instance.post(url, { fullPath });
      if (
        response.data &&
        response.data.data &&
        response.data.data.length === 0
      ) {
        message.error('No se ha encontrado la cotización');
        setCotizacion([]);
      } else {
        const cotResponse = response.data.data;
        setCotizacion(cotResponse[0]);
      }
    } catch (error) {
      errorHandler(error, 'No se pudo obtener la cotización');
      setCotizacion([]);
      setLoading(false);
      if (error.response && error.response.status === 400) {
        history.push(
          `/regenerar-token?flujo=cotizacion&tokenExpirado=${token}`
        );
      }
    }

    setLoading(false);
  }, [props.match.params, history, fullPath]);

  const updateData = useCallback((stepKey, newData) => {
    setFormData((prev) => ({
      ...prev,
      [stepKey]: { ...prev[stepKey], ...newData }
    }));
  }, []);

  const getIngreso = (ingreso) => {
    switch (ingreso) {
      case '1':
        return 2000000;
      case '2':
        return 6000000;
      case '3':
        return 11000000;
      case '4':
        return 16000000;
      default:
        return 0;
    }
  };

  const onClickContinuarCedulaEditada = async () => {
    let datosObtenidos;
    setLoading(true);
    setConfirmarCedulaLoading(true);
    setMostrarConfirmarCedula(false);

    const numeroCedulaUsuario = formCedula.getFieldValue(
      'numeroCedulaModificada'
    );
    setNumeroCedulaModificada(numeroCedulaUsuario);

    // Si hay incosistencia de nombres pero el usuario no modifica, se prioriza con los noombres de BCP o vacio.

    if (numeroCedulaUsuario === numeroCedula) {
      setDocumentosData((prevData) => ({
        ...prevData,
        CIA: {
          ...prevData.CIA,
          nombres: prevData.CIA.nombresBcp ? prevData.CIA.nombresBcp : '',
          cedula: numeroCedulaUsuario,
          nombre: prevData.CIA.nombreBcp ? prevData.CIA.nombreBcp : '',
          apellido: prevData.CIA.apellidoBcp ? prevData.CIA.apellidoBcp : ''
        }
      }));
    }

    // Si el usuario ingresa otro numero de cedula, se envian los datos

    if (numeroCedulaUsuario !== numeroCedula) {
      datosObtenidos = await consultarCliente(
        cotizacion.aseguradoraEmpresa.id_aseguradora,
        numeroCedulaUsuario,
        cotizacion.id
      );
      if (datosObtenidos && datosObtenidos.clienteExterno) {
        setDocumentosData((prevData) => ({
          ...prevData,
          CIA: {
            ...prevData.CIA,
            nombres: datosObtenidos.clienteExterno.nombre_apellido,
            cedula: numeroCedulaUsuario,
            nombre: datosObtenidos.clienteExterno.nombreBcp,
            apellido: datosObtenidos.clienteExterno.apellidoBcp
          }
        }));
      } else {
        setDocumentosData((prevData) => ({
          ...prevData,
          CIA: {
            ...prevData.CIA,
            nombres: '',
            cedula: numeroCedulaUsuario,
            nombre: '',
            apellido: ''
          }
        }));
      }
    }
    setLoading(false);
    setConfirmarCedulaLoading(false);

    // Espera a que `datosObtenidos` se obtenga antes de avanzar al siguiente paso
    if (numeroCedulaUsuario === numeroCedula || datosObtenidos) {
      setCurrent(1);
    }
  };

  const solicitar = async (type) => {
    setLoading(true);

    const fieldsData = formData.fields;
    if (fieldsData.prefijoTelEmpleador) {
      fieldsData.telefonoEmpleador = concatTelefono(
        fieldsData.prefijoTelEmpleador,
        fieldsData.sufijoTelEmpleador
      );
    }

    // fields.tercero.telefono = concatTelefono(
    //   prefijoTelefono,
    //   sufijoTelefono
    // );

    // si politicamenteExpuesto es false entonces no sse deben guardar sus otros valores

    const filesToSend = [];
    if (cedulaIdentidad1) {
      filesToSend.push(cedulaIdentidad1);
    }
    if (cedulaIdentidad2) {
      filesToSend.push(cedulaIdentidad2);
    }
    if (cedulaVerde1) {
      filesToSend.push(cedulaVerde1);
    }
    if (cedulaVerde2) {
      filesToSend.push(cedulaVerde2);
    }

    const cotizacionNew = {
      ...cotizacion,
      persona: {
        ...cotizacion.persona,
        id: cotizacion.persona.id,
        cedula: fieldsData.cedula,
        nombres: fieldsData.nombres,
        nombre: fieldsData.nombreBcp,
        apellido: fieldsData.apellidoBcp,
        celular: `${fieldsData.prefix}${formatCelular(fieldsData.celular)}`,
        correo: fieldsData.correo,
        domicilio: fieldsData.domicilio,
        id_departamento: fieldsData.departamento,
        id_distrito: fieldsData.distrito,
        nacionalidad: fieldsData.nacionalidad,
        sexo: fieldsData.sexo,
        estado_civil: fieldsData.estadoCivil,
        lugar_nacimiento: fieldsData.lugarNacimiento,
        fecha_nacimiento: fieldsData.fechaNacimiento
          ? fieldsData.fechaNacimiento.format('DD/MM/YYYY')
          : '',
        ruc: fieldsData.ruc,
        profesion: fieldsData.profesion,
        ingresos: getIngreso(fieldsData.ingresos),
        proveedor_estado: fieldsData.proveedorEstado ? 'Sí' : 'No',
        expuesta_politicamente: fieldsData.politicamenteExpuesto ? 'Sí' : 'No',
        vinculo: fieldsData.vinculo,
        entidad: fieldsData.entidad,
        periodo: fieldsData.periodo,
        tipo_empleado: fieldsData.trabajo,
        institucion_publica: fieldsData.institucion,
        institucion_cargo: fieldsData.cargo,
        institucion_anhoingreso: fieldsData.anioIngreso,
        empleador_ruc: fieldsData.rucEmpleador || 'A Confirmar',
        empleador_empresa: fieldsData.empresaEmpleador,
        empleador_telefono: fieldsData.telefonoEmpleador || 'A Confirmar',
        empleador_celular: fieldsData.celularEmpleador
          ? `${fieldsData.prefix}${formatCelular(fieldsData.celularEmpleador)}`
          : 'A Confirmar',
        empleador_direccion: fieldsData.direccionEmpleador,
        juridica: false,
        latitud: null,
        longitud: null,
        personaBCP: fieldsData.personaBCP // TODO: ver de sacar de documentos
        // datos_externos: {
        //   ...datosExternosPersona,
        //   imagen: {
        //     ...datosExternosPersona.imagen,
        //     ...datosExternosPersonaImagenCID
        //   }
        // }
      },

      vehiculo: {
        ...cotizacion.vehiculo,
        chassis: fieldsData.chassis || fields.chassis,
        chapa: fieldsData.chapa || fields.chapa
      }
    };

    const solicitud = {
      formaPago: fieldsData.formaPago,
      idMetodoPago: fieldsData.metodoPago,
      idModalidadPago: 7, // id 7 total contado
      idVigenciaPago: 9, // diario
      numeroTarjeta: '',
      titularTarjeta: '',
      vencimientoTarjeta: '',
      marcaTarjeta: '',
      numeroCuenta: '',
      cotizacion: cotizacionNew,
      plan: cotizacion.planes[0].id, // TODO: existe un solo plan ya preseleccionado para la cotizacion de carta verde, ver cuando es moneda USD
      files: filesToSend,
      tercero: {
        ...fieldsData.tercero,
        celular: fieldsData.tercero.celular
          ? `${fieldsData.prefix}${formatCelular(fieldsData.tercero.celular)}`
          : null,
        telefono: fieldsData.tercero.telefono
      },
      empresaJuridica: undefined,
      vigencia: {
        fechaInicioVigencia: fieldsData.vigencia.desde,
        fechaFinVigencia: fieldsData.vigencia.hasta,
        cantidadDias: fieldsData.vigencia.cantidad_dias
      },
      numeroCuotas: 1, // contado
      pagos: {
        list: [
          {
            fecha: new Date(), // TODO: ver fechas
            numero: 1,
            fechaVencimiento: new Date(), // TODO: ver fechas
            monto: cotizacion.planes[0].monto_total //  TODO: el monto debe ser el calculado en monto del periodo
          }
        ],
        numeroCuotas: 1
      }
    };
    try {
      await solicitarRequest(solicitud, empresa, type, undefined);
      setLoading(false);
      // setIsDirty(false);
      setSolicitado(true);
    } catch (error) {
      setLoading(false);
      errorHandler(error, 'Error al enviar la solicitud');
      //  setIsDirty(true);
    }
    setSolicitado(true);
  };

  useEffect(() => {
    updateData('documentos', documentosData);
  }, [documentosData, updateData]);

  useEffect(() => {
    if (cotizacion?.vehiculo) {
      const { vehiculo, persona, vigencia } = cotizacion;
      const fechaDesdeMoment = moment(
        vigencia.fechaInicioVigencia,
        'YYYY-MM-DD'
      );
      const fechaHastaMoment = moment(vigencia.fechaFinVigencia, 'YYYY-MM-DD');

      const empresaMetodoPagoList =
        cotizacion.aseguradoraEmpresaProducto?.empresaProductoMetodo;
      let empresaMetodoPago = null;
      // si el admin modifica el metodoPago a Caja/Ventanilla se debe setear el metodo que corresponde.
      if (empresaMetodoPagoList && empresaMetodoPagoList.length > 0) {
        if (cotizacion.metodo_pago_modificado) {
          empresaMetodoPago = empresaMetodoPagoList.find(
            ({ metodoPago }) => metodoPago.codigo === 'caja'
          );
        } else {
          empresaMetodoPago = empresaMetodoPagoList.find(
            ({ metodoPago }) => metodoPago.codigo === 'tarjeta'
          );
        }
      }
      setFields((prev) => ({
        ...prev,
        chassis: vehiculo.chassis,
        chapa: vehiculo.chapa,
        marca: vehiculo.id_marca,
        modelo: vehiculo.id_modelo,
        submodelo: vehiculo.id_submodelo,
        anio: vehiculo.aniosubmodelo.descripcion,
        celular: persona?.celular ? parseCelular(persona.celular) : null,
        correo: persona?.correo || null,
        vigencia: {
          desde: fechaDesdeMoment.isValid() ? fechaDesdeMoment : null,
          hasta: fechaHastaMoment.isValid() ? fechaHastaMoment : null,
          cantidad_dias: vigencia.cantidadDias,
          dias: vigencia.cantidadDias
        },
        metodoPago: empresaMetodoPago?.metodoPago?.id,
        metodoPagoDescripcion: empresaMetodoPago?.metodoPago?.descripcion
      }));
    }
  }, [cotizacion]);

  useEffect(() => {
    const fileData = formData.documentos?.CIA;
    if (fileData) {
      const fechaMoment = moment(fileData.fechaNacimiento, 'DD/MM/YYYY');
      const newCIA = {
        nombres: fileData.nombres,
        cedula: fileData.cedula,
        nombre: fileData.nombreBcp,
        apellido: fileData.apellidoBcp,
        ruc: fileData.ruc,
        sexo: fileData.sexo,
        lugarNacimiento: fileData.lugarNacimiento,
        personaBCP: fileData.tipoDataBCP,
        fechaNacimiento: fechaMoment.isValid() ? fechaMoment : null
      };
      const newTerceroCIA = {
        nombres: fileData.razonSocial || fileData.nombres,
        cedula: fileData.cedula,
        ruc: fileData.ruc,
        celular: fields.celular,
        domicilio: fileData.persona?.domicilio || '',
        correo: fileData.persona?.correo || ''
      };

      setFields((prev) => ({
        ...prev,
        ...newCIA,
        tercero: {
          ...prev.tercero,
          ...newTerceroCIA
        }
      }));
      formAsegurado.setFieldsValue({
        ...newCIA,
        tercero: { ...newTerceroCIA }
      });

      setNumeroCedula(fileData.cedula);

      formCedula.setFieldsValue({ numeroCedulaModificada: fileData.cedula });
    }
  }, [formData.documentos?.CIA, fields.celular, formAsegurado, formCedula]);

  useEffect(() => {
    // Procesar documentos CVA
    const fileDataCVA = formData.documentos?.CVA;
    if (fileDataCVA) {
      const departamento = fileDataCVA.departamentoSelected?.id || null;
      const distrito = fileDataCVA.distritoSelected?.id || null;
      const domicilio = fileDataCVA.domicilio || null;
      const newCVA = {
        departamento,
        distrito,
        domicilio
      };
      const newTerceroCVA = {
        id_departamento: departamento,
        id_distrito: distrito,
        domicilio
      };

      setFields((prev) => ({
        ...prev,
        ...newCVA,
        tercero: {
          ...prev.tercero,
          ...newTerceroCVA
        }
      }));

      formAsegurado.setFieldsValue({
        ...newCVA,
        tercero: { ...newTerceroCVA }
      });
    }

    // Procesar documentos CID
    const fileDataCID = formData.documentos?.CID;
    if (fileDataCID) {
      const nacionalidad =
        fileDataCID.nacionalidad === NACIONALIDADES[0].descripcion
          ? NACIONALIDADES[0].descripcion
          : NACIONALIDADES[1].descripcion;

      const estado = ESTADOS.find(
        ({ descripcion }) => descripcion === fileDataCID.estadoCivil
      );
      const estadoCivil = estado?.descripcion || undefined;

      const newCID = {
        nacionalidad,
        estadoCivil
      };

      setFields((prev) => ({
        ...prev,
        ...newCID
      }));

      formAsegurado.setFieldsValue({
        ...newCID
      });
    }
  }, [formData.documentos?.CVA, formData.documentos?.CID, formAsegurado]);

  useEffect(() => {
    // Si sube o modifica la cedula frontal, se resetea el valor del numeroo de ceddula modificada
    if (cedulaIdentidad1) {
      setNumeroCedulaModificada(null);
    }
  }, [cedulaIdentidad1, setNumeroCedulaModificada]);

  useEffect(() => {
    if (fields) {
      updateData('fields', fields);
    }
  }, [fields, updateData]);

  useEffect(() => {
    getCotizacion();
  }, [getCotizacion]);

  return (
    <>
      <LogosEmpresaAseguradora />
      <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
        {cotizacion && (
          <ResponsiveContainer
            size={current !== 0 ? 'large' : undefined}
            //  style={{ maxWidth: current === 0 && maxWidthHoja }}
          >
            {cotizacion?.solicitado ? (
              <SolicitudRealizada />
            ) : (
              <Card>
                <Title>Solicitá tu Seguro de Carta Verde</Title>
                <>
                  <div>
                    {current !== steps.length - 1 && (
                      <StepperSolicitud
                        current={current}
                        steps={steps.slice(0, 3)}
                      />
                    )}
                  </div>

                  {current === 0 && cotizacion && (
                    <>
                      <br />
                      <Subtitle>{steps[current].description}</Subtitle>

                      <DocumentosCartaVerdeUpload
                        screens={screens}
                        pasoDocumento={subpasoDocumentos}
                        setDocumentosData={setDocumentosData}
                        idCotizacion={Number(cotizacion.id)}
                        empresaId={Number(cotizacion.id_empresa)}
                        aseguradoraId={Number(
                          cotizacion.aseguradoraEmpresa.id_aseguradora
                        )}
                        token={cotizacion.token}
                        cedulaVerde={{
                          cedulaVerde1,
                          setCedulaVerde1,
                          cedulaVerde2,
                          setCedulaVerde2
                        }}
                        cedulaIdentidad={{
                          cedulaIdentidad1,
                          setCedulaIdentidad1,
                          cedulaIdentidad2,
                          setCedulaIdentidad2
                        }}
                        setLoadingPrincipalImagen={setLoadingPrincipalImagen}
                      />
                      <ReconfirmarCIAModal
                        formCedula={formCedula}
                        mostrarConfirmarCedula={mostrarConfirmarCedula}
                        onClickContinuarCedulaEditada={
                          onClickContinuarCedulaEditada
                        }
                        loading={confirmarCedulaLoading}
                      />
                    </>
                  )}
                  {current === 1 && (
                    <>
                      <br />
                      <Subtitle>{steps[current].description}</Subtitle>
                      <SolicitudCartaVerdeForm
                        data={formData}
                        updateData={updateData}
                        empresaProductoMetodo={
                          cotizacion.aseguradoraEmpresaProducto
                            .empresaProductoMetodo
                        }
                        forms={{
                          formVehiculo,
                          formAsegurado,
                          formLaborales,
                          formPeriodo,
                          formMetodo
                        }}
                      />
                    </>
                  )}
                  {current === 2 && (
                    <DescripcionesCartaVerde
                      fields={{ ...formData.fields }}
                      screens={screens}
                    />
                  )}

                  {current === 3 && (
                    <PagosCartaVerdeForm token={cotizacion.token} />
                  )}

                  {!solicitado && subpasoDocumentos !== 0 && (
                    <Button
                      style={{ margin: 10 }}
                      onClick={onAnterior}
                      // disabled={principalLoading}
                    >
                      Anterior
                    </Button>
                  )}
                  {current < 2 && (
                    <Button
                      disabled={loadingPrincipalImagen}
                      type="primary"
                      style={{ margin: 10 }}
                      onClick={onSiguiente}
                    >
                      Siguiente
                    </Button>
                  )}
                  {current === 2 && (
                    <Button
                      // disabled={loading1 || loading2}
                      type="primary"
                      style={{ margin: 10 }}
                      onClick={solicitar}
                    >
                      Finalizar
                    </Button>
                  )}
                </>
              </Card>
            )}
          </ResponsiveContainer>
        )}
      </Spin>
    </>
  );
};

const PreSolicitudCartaVerde = (props) => {
  const location = useLocation();
  const fullPath = location.pathname;
  return (
    <SolicitudProvider>
      <PreSolicitudFormFinal fullPath={fullPath} {...props} />
    </SolicitudProvider>
  );
};

export default PreSolicitudCartaVerde;
